import React, { useState, useEffect } from 'react'
import { Table, Panel, ButtonToolbar, IconButton, Icon, Row, Col } from 'rsuite'
import '../styles.less'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { tableViewSize } from '../../../utils/tableViewSizeUtil'

const basicColumns = [
  { dataKey: 'no', headerKey: 'l2No', width: 80, align: 'center' },
  { dataKey: 'budgetYear', headerKey: 'l2Budgetyear', width: 120, align: 'center' },
  { dataKey: 'contrectNo', headerKey: 'l2ContrectNo', width: 140 },
  { dataKey: 'projectCode', headerKey: 'l2ProjectCode', width: 130 },
  { dataKey: 'projectName', headerKey: 'l2ProjectName', width: 350 },
  { dataKey: 'department', headerKey: 'l2Department', width: 150 },
  { dataKey: 'coordinator', headerKey: 'l2Coordinator', width: 200 },
  { dataKey: 'granteeType', headerKey: 'l2GranteeType', width: 150 },
  { dataKey: 'organizationName', headerKey: 'l2OrganizationName', width: 280 },
  { dataKey: 'organizationAddress', headerKey: 'l2OrganizationAddress', width: 360 },
  { dataKey: 'organizationProvince', headerKey: 'l2OrganizationProvince', width: 180 },
  { dataKey: 'granteeName', headerKey: 'l2GranteeName', width: 200 },
  { dataKey: 'responsibility', headerKey: 'l2Responsibility', width: 200 },
  { dataKey: 'startDate', headerKey: 'l2StartDate', width: 140, align: 'center' },
  { dataKey: 'endDate', headerKey: 'l2EndDate', width: 180, align: 'center' },
  { dataKey: 'projectBudget', headerKey: 'l2ProjectBudget', width: 170, align: 'right' },
  { dataKey: 'projectStatus', headerKey: 'l2ProjectStatus', width: 150 },
  { dataKey: 'agreementEndDate', headerKey: 'l2AgreementEndDate', width: 240, align: 'center' },
  {
    dataKey: 'dayContractDuration',
    headerKey: 'l2DayContractDuration',
    width: 220,
    align: 'right',
  },
]

const summarizeColumns = [
  { dataKey: 'reqCount', headerKey: 'l2ReqCount', width: 180, align: 'right' },
  { dataKey: 'reqCountDay', headerKey: 'l2ReqCountDay', width: 180, align: 'right' },
  { dataKey: 'reqPercentage', headerKey: 'l2ReqPercentage', width: 180, align: 'right' },
  { dataKey: 'reqReason', headerKey: 'l2ReqReason', width: 360, align: 'right' },
  { dataKey: 'reqSubReason', headerKey: 'l2ReqSubReason', width: 360, align: 'right' },
  { dataKey: 'reqReasonEtc', headerKey: 'l2ReqReasonEtc', width: 360, align: 'right' },
]

export default function ExtentionTimeOverviewReportTable({
  schema,
  headerHeightSize,
  onRemove,
  onReload,
  pagination,
  lengthMenu,
  loading,
  Controller,
  control,
  runingNumber,
  onClickExport,
  onClickLinked,
  shaded = true,
  ...props
}) {
  let fontSize = localStorage.getItem('fontSize')

  const { Column, ColumnGroup, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(25)
  const [page, setPage] = useState(1)
  const [viewSize, setViewSize] = useState([])
  const [heightSize, setHeightSize] = useState(40)

  const defaultPage = 1
  const header = schema?.header || {}
  const totalSize = Number(header.totalSize || schema?.totalSize || schema?.values?.length || 0)

  useEffect(() => {
    calHeaderHeightSize()
    setViewSize(tableViewSize(totalSize))
  }, [totalSize])

  useEffect(() => {
    const schemaDisplayLength = Number(header.displayLength)

    if (schemaDisplayLength) {
      setDisplayLength(schemaDisplayLength)
    }
  }, [header.displayLength])

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey)
    }
  }

  const calHeaderHeightSize = () => {
    const size = fontSize <= 15 ? 40 : 80
    setHeightSize(size)
  }

  const renderColumn = (column) => {
    return (
      <Column
        width={column.width}
        resizable={true}
        align={column.align || 'left'}
        key={column.dataKey}
      >
        <HeaderCell style={{ textAlign: 'center', ...(column.headerStyle || {}) }}>
          {column.label || header[column.headerKey] || ''}
        </HeaderCell>
        {/* <Cell dataKey={column.dataKey} style={column.cellStyle || {}} /> */}
        <Cell style={column.cellStyle || {}}>
          {(rowData, index) => {
            return (
              <div
                style={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              >
                {rowData[column.dataKey]}
              </div>
            )
          }}
        </Cell>
      </Column>
    )
  }

  const renderSchemaColumns = () => {
    return [
      <ColumnGroup header={header.l1Header || ''} key="basic">
        {basicColumns.map(renderColumn)}
      </ColumnGroup>,
      <ColumnGroup header={header.l1Summarize || ''} key="summarize">
        {summarizeColumns.map(renderColumn)}
      </ColumnGroup>,
      <Column width={20} key="end-spacer">
        <HeaderCell>{''}</HeaderCell>
        <Cell>{''}</Cell>
      </Column>,
    ]
  }

  const tableData = schema?.values || []

  return (
    <>
      <br />
      <Panel shaded={shaded} header={schema?.header?.header || ''} collapsible defaultExpanded>
        {schema.exportButton && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'right' }}>
              <IconButton
                appearance="ghost"
                size="sm"
                style={{
                  marginRight: 10,
                }}
                onClick={onClickExport}
                icon={
                  <Icon appearance="ghost" icon="file-excel-o" className="bt-gost-icon-radius" />
                }
              >
                {schema.exportButton}
              </IconButton>
            </Col>
          </Row>
        )}

        <div className="table-affix-header">
          <Table
            wordWrap
            bordered
            cellBordered
            height={schema.tableHeight || 400}
            loading={loading}
            headerHeight={headerHeightSize || heightSize * 2}
            data={tableData}
            style={{ marginTop: '20px' }}
            autoHeight
            affixHeader
          >
            {renderSchemaColumns()}
          </Table>
        </div>

        {pagination && (
          <TablePagination
            lengthMenu={lengthMenu || viewSize}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 25}
            total={totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}
      </Panel>
    </>
  )
}
